/**
 * @generated SignedSource<<09a353b8ae0c6081450fe654265c0f9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImagesTabImagesList_imageRecords$data = {
  readonly imageRecordsByAsset: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ImageItem_imageRecord">;
      };
    }>;
  };
  readonly " $fragmentType": "ImagesTabImagesList_imageRecords";
};
export type ImagesTabImagesList_imageRecords = ImagesTabImagesList_imageRecords$data;
export type ImagesTabImagesList_imageRecords$key = {
  readonly " $data"?: ImagesTabImagesList_imageRecords$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImagesTabImagesList_imageRecords">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "imageRecordsByAsset"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "assetId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ImageRecordListPaginationQuery.graphql')
    }
  },
  "name": "ImagesTabImagesList_imageRecords",
  "selections": [
    {
      "alias": "imageRecordsByAsset",
      "args": [
        {
          "kind": "Variable",
          "name": "assetId",
          "variableName": "assetId"
        }
      ],
      "concreteType": "ImageRecordConnection",
      "kind": "LinkedField",
      "name": "__ImageRecordList_imageRecordsByAsset_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageRecordEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageRecord",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ImageItem_imageRecord"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "ad024f185809d5c5d7c733ea3ae3291b";

export default node;
